module.exports = __webpack_public_path__ + "img/network-equipment.470b81c.png";